import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractMoreInput} from "../abstract-more-input";
import {FUIOptionsService} from "../../../framework/options.service";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPopMoreInputComponent),
            multi: true
        }
    ],
    selector: "fui-pop-more-input",
    templateUrl: "./pop-more-input.component.html"
})
export class FUIPopMoreInputComponent extends FUIAbstractMoreInput {
    constructor(elementRef: ElementRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, eventsService, optionsService, changeDetectorRef);
    }
}
